import { FC } from 'react';
import { Helmet } from 'react-helmet-async';

import {
  Calculation,
  calculationMode,
} from '@/components/Calculation/Calculation';

export const Multiplication: FC = () => {
  return (
    <>
      <Helmet>
        <title>Jula - Multiplication</title>
      </Helmet>
      <Calculation mode={calculationMode.multiplication} />
    </>
  );
};
